import script from "./GlobalCatalogUI.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalCatalogUI.vue?vue&type=script&setup=true&lang=js"

import "./GlobalCatalogUI.vue?vue&type=style&index=0&id=bf4024ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4024ce"]])

export default __exports__